// import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
// import React, { useEffect, useState } from 'react'
// import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
// import * as bie from "react-bootstrap";
// import * as Yup from 'yup';
// import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables';
// import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
// import Swal from 'sweetalert2';
// import { config } from '../../CommonUtils/CommonURLS';
// import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
// import { digisignFunction } from '../../CommonUtils/DIGISIGN/digisignFunction';
// import { showPDF } from '../../CommonUtils/DIGISIGN/convertFileToBase64';
// import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
// import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import { BackButton } from '../../CommonUtils/CommonServices';
// export default function AfflOrderGenDetails() {
//     const location = useLocation()
//     const acYear = sessionStorage.getItem('ac_year');
//     const collegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
//     const [viewpdf, setViewpdf] = useState('');
//     const [hidepdf, setHidepdf] = useState(false);
//     const [pdfUrl, setPdfUrl] = useState(null);
//     let pageName = location?.state?.type;

//     const [collegeRecommendation, setCollegeRecommendation] = useState('');
//     function getRecommendation() {
//         const url = `${config.url.API_URL}recomdation/${collegeCode}/${acYear}`;
//         CommonAxiosGet(url)
//             .then((res) => {
//                 if (res?.data?.scode === "01") {
//                     setCollegeRecommendation(res?.data?.recomdation[0]);
//                 } else {
//                     setCollegeRecommendation('');
//                 }
//             })

//     }
//     const [clgCategory, setClgCategory] = useState('');
//     function GetCollegeCategory() {
//         let url = config.url.API_URL + "clgCategory/" + collegeCode + "/" + acYear;
//         CommonAxiosGet(url).then((res) => {
//             if (res) {
//                 setClgCategory(res?.data)
//                 afflOrderGenFormik.setFieldValue("clgcatflag", res?.data)

//             } else {
//                 setClgCategory([])
//             }
//         })
//     }
//     useEffect(() => {
//         GetCollegeCategory();
//         getRecommendation();
//     }, [])


//     const AfflOrderDetailsValidation = Yup.object().shape({
//         accordedBy: Yup.string().required(ERROR_MSG).nullable(),
//         authorityBy: Yup.string().required(ERROR_MSG).nullable(),
//         afflOrderProcNo202223: Yup.string().required(ERROR_MSG).nullable(),
//         //                            
//         gortNo3: Yup.string().when(['clgcatflag', "clgtype"], {
//             is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "OAMDC",
//             then: Yup.string().required(ERROR_MSG).nullable(),
//             otherwise: Yup.string().notRequired(),
//         }),
//         gortDate3: Yup.string().when(['clgcatflag', "clgtype"], {
//             is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "OAMDC",
//             then: Yup.string().required(ERROR_MSG).nullable(),
//             otherwise: Yup.string().notRequired(),
//         }),

//         //
//         afflOrder202021Date: Yup.string().when(['clgcatflag', "clgtype"], {
//             is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
//             then: Yup.string().required(ERROR_MSG).nullable(),
//             otherwise: Yup.string().notRequired(),
//         }),

//         afflOrderProcNo202021: Yup.string().when(['clgcatflag', "clgtype"], {
//             is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
//             then: Yup.string().required(ERROR_MSG).nullable(),
//             otherwise: Yup.string().notRequired(),
//         }),

//         // universityEcDate: Yup.string().nullable().when("clgcatflag", {
//         //     is: (value) => value === 0,
//         //     then: Yup.string().required(ERROR_MSG).nullable(),
//         //     otherwise: Yup.string().notRequired(),
//         // }),

//         //  ecDecision: Yup.string().when(['clgcatflag', "clgtype"], {
//         //         is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
//         //         then: Yup.string().required(ERROR_MSG).nullable(),
//         //         otherwise: Yup.string().notRequired(),
//         //     }),

//         registrarRemarks: Yup.string().required(ERROR_MSG).nullable(),
//     });

//     const [modal, setModal] = useState(false);
//     const handleClose = () => {
//         setModal(false);
//         setPdfUrl('');
//     };

//     const afflOrderGenFormik = useFormik({
//         enableReinitialize: true,
//         initialValues: {
//             collCode: collegeCode,
//             acYear: acYear,
//             clgcatflag: "",
//             clgtype: pageName,
//             finalPdfPath: "",
//             universityEcDoc: "",
//             gortNo: "",
//             gortDate: "",
//             gortNo2: "",
//             gortDate2: '',
//             gortNo3: "",
//             gortNo4: "",
//             gortDate3: "",
//             gortDate4: "",
//             accordedBy: "",
//             authorityBy: "",
//             afflOrder202021Date: "",
//             afflOrderProcNo202021: "",
//             afflOrder202223Date: "",
//             afflOrderProcNo202223: "",
//             universityEcDate: "",
//             ecDecision: "",
//             registrarRemarks: "",
//             afflType: "",
//             remarks: "",

//         },
//         validationSchema: AfflOrderDetailsValidation,
//         validateOnBlur: true,
//         validateOnChange: true,
//         context: {
//             clgCategory,
//         },
//         onSubmit: (values) => {
//             if (values.gortDate4) {
//                 const [year, month, day] = values.gortDate4.split("-");
//                 values.gortDate4 = `${day}/${month}/${year}`;
//             }
//             // if (values.gortDate3) {
//             //     const [year, month, day] = values.gortDate3.split("-");
//             //     values.gortDate3 = `${day}/${month}/${year}`;
//             // }
//             Swal.fire({
//                 text: 'Are you sure you want to submit?',
//                 icon: 'warning',
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes, submit it!',
//                 cancelButtonText: 'No, cancel!',
//                 backdrop: false,


//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     const url = `${config.url.API_URL}saveAfflOrderGeneration`;
//                     CommonAxiosPost(url, values).then((res) => {
//                         if (res?.data?.Status === true) {
//                             setHidepdf(true)
//                             successAlert2(res?.data?.sdesc);
//                             setViewpdf(res?.data?.path)
//                         } else {
//                             failureAlert("Failed to submit");
//                         }
//                     });
//                 }
//             });
//         }
//     })


//     async function dskConfirmationFunc() {
//         if (viewpdf !== null && viewpdf !== undefined && viewpdf !== "") {
//             try {
//                 let img = config.url.FILE_DOWNLOAD_URL + viewpdf
//                 const base64Data = await showPDF(img);
//                 const extractedData = base64Data;
//                 let postData = {
//                     path: config.url.API_URL + "saveAfflOrder",
//                     params: {
//                         collCode: collegeCode,
//                         acYear: acYear,
//                         // finalPdfPath: viewpdf,
//                     }
//                 }
//                 digisignFunction(extractedData, "-1", postData, "", pageName);
//             } catch (error) {
//                 console.error("Error:", error);
//             }
//         }
//     }
//     const showViewPDF = (imgg) => {
//         ConvertFileToBase64(imgg).then(base64Data => {
//             const extractedData = base64Data.split(',')[1];
//             const binaryData = atob(extractedData);
//             const arrayBuffer = new ArrayBuffer(binaryData.length);
//             const uint8Array = new Uint8Array(arrayBuffer);
//             for (let i = 0; i < binaryData.length; i++) {
//                 uint8Array[i] = binaryData?.charCodeAt(i);
//             }
//             const blob = new Blob([uint8Array], { type: 'application/pdf' });
//             const url = URL.createObjectURL(blob);
//             setPdfUrl(url);
//             setModal(true);
//         })
//     };

//     async function ConvertFileToBase64(fileUrl) {
//         const response = await fetch(fileUrl);
//         const blob = await response.blob();
//         return await new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader?.result);
//             reader.onerror = reject;
//             reader.readAsDataURL(blob);
//         })
//     }
//     return (
//         <>
//             <CommonFormHeading heading={`Affiliation Order Details ${acYear}`} />
//             <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

//                 <bie.Row>
//                     <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} ></bie.Col>

//                     <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} >

//                         <BackButton />

//                     </bie.Col>

//                 </bie.Row>
//                 <FormikProvider value={afflOrderGenFormik}>

//                     <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="form_adjust" >

//                         <bie.Row className="px-2 pt-3 mb-3">
//                             {pageName === "OAMDC" && (<>
//                                 <bie.Alert variant='danger' className='affl-alert'>  Please enter the details with care, as they will be appearing in the Digital Affiliation Order </bie.Alert>
//                                 <b style={{ fontSize: "19px", color: "brown" }}> mandatory: </b>

//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Final Recommendations of CDC Dean:</label>
//                                         <b>  {collegeRecommendation?.final_recomondation_cdc_dean}</b>
//                                     </bie.Col>
//                                 </bie.Row>
//                             </>)}

//                             {/* except law college nonoamdc */}
//                             {clgCategory === 0 && pageName === "NONOAMDC" && (<>
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Reference Number of the Proceedings of AICTE/CHE/PCI/BCI/NCTE that stands as reference in the Affiliation Order {acYear}: 1.</label>
//                                         <Field type='text' name="gortNo" className='form-control' maxLength={60} />
//                                         <ErrorMessage name="gortNo" component="div" className="text-error" />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Date of Proceedings of AICTE/CHE/PCI/BCI/NCTE that stands as reference in the  Affiliation Order {acYear}:1</label>
//                                         <Field type='date' name="gortDate" className='form-control mb-2' />
//                                         <ErrorMessage name="gortDate" component="div" className="text-error" />
//                                     </bie.Col>
//                                 </bie.Row>
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Reference Number of the Proceedings of Latest EC Meeting:2</label>
//                                         <Field type='text' name="gortNo2" className='form-control mb-2' maxLength={60} />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Date of Reference Number of the Proceedings of Latest EC Meeting:2</label>

//                                         <Field type='date' name="gortDate2" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                     </bie.Col>
//                                 </bie.Row>
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Reference Number of the Proceedings/Order/Letter/Report:3</label>

//                                         <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Date of Reference Number of the Proceedings/Order/Letter/Report:3</label>

//                                         <Field type='date' name="gortDate3" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                     </bie.Col>
//                                 </bie.Row>
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Reference Number of the Proceedings/Order/Letter/Report:4</label>

//                                         <Field type='text' name="gortNo4" className='form-control mb-2' maxLength={60} />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label >Date of Reference Number of the Proceedings/Order/Letter/Report:4</label>

//                                         <Field type='date' name="gortDate4" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                     </bie.Col>
//                                 </bie.Row>
//                             </>)}

//                             <bie.Row>
//                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                     <label className='field-mandatory'>Competent Authority that has given Permission (EOA/EOP/Any Other Permission Proceedings that is pre-requisite for Granting Affiliation):</label>
//                                     <Field type='text' name="accordedBy" className='form-control' maxLength={60} />
//                                     <ErrorMessage name="accordedBy" component="div" className="text-error" />
//                                 </bie.Col>
//                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                     <label className='field-mandatory mb-1'>Affiliation Order {acYear} being approved by: </label>
//                                     <Field as="select" name="authorityBy" className="form-control mb-2 mt-3">
//                                         <option value="">--Select--</option>
//                                         {/* <option value="REGISTRAR">REGISTRAR</option> */}
//                                         <option value="VICE-CHANCELLOR">VICE-CHANCELLOR</option>
//                                     </Field>
//                                     <ErrorMessage name="authorityBy" component="div" className="text-error" />
//                                 </bie.Col>
//                             </bie.Row>
//                             {/* nonoamdc except law */}
//                             {clgCategory === 0 && pageName === "NONOAMDC" && (
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory'>Date of Affiliation Order {AC_YEAR_OLD}:</label>
//                                         <Field type='date' name="afflOrder202021Date" className='form-control mb-2 mt-3'
//                                             onKeyDown={(e) => { e.preventDefault() }} />
//                                         <ErrorMessage name="afflOrder202021Date" component="div" className="text-error" />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory mb-1'>Proceedings Number of Affiliation Order {AC_YEAR_OLD}: </label>
//                                         <Field type='text' name="afflOrderProcNo202021" className='form-control mb-2 mt-3' maxLength={100} />
//                                         <ErrorMessage name="afflOrderProcNo202021" component="div" className="text-error" />
//                                     </bie.Col>

//                                 </bie.Row>
//                             )}



//                             <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                 <label className='field-mandatory mb-1'>University Proceedings Number of Affiliation Order {acYear}: </label>
//                                 <Field type='text' name="afflOrderProcNo202223" className='form-control mb-2 mt-3' maxLength={60} />
//                                 <ErrorMessage name="afflOrderProcNo202223" component="div" className="text-error" />
//                             </bie.Col>
//                             <bie.Col xs={12} sm={12} md={12} lg={2} xl={6} xxl={6} className='mb-2'>
//                                 <label className='field-mandatory mb-1'>Date of Affiliation Order {acYear}:</label>
//                                 <Field type='date' name="afflOrder202223Date" className='form-control mb-2 mt-3'
//                                     value={new Date().toISOString().split('T')[0]}
//                                     readOnly />
//                             </bie.Col>

//                             <bie.Row>
//                                 {clgCategory === 0 && pageName === "NONOAMDC" && (
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>EC Decision : </label>
//                                         <Field as='select' name="ecDecision" className='form-control mb-2'>
//                                             <option value="">--Select--</option>
//                                             <option value="Permanent Affiliation">Permanent Affiliation</option>
//                                             <option value={`Temporary Affiliation for AY ${acYear}`}>
//                                                 Temporary Affiliation for AY {acYear}
//                                             </option>
//                                             <option value={`Conditional Affiliation for AY ${acYear} subject to rectifying the deficiencies within 3 months`}>
//                                                 Conditional Affiliation for AY {acYear} subject to rectifying the deficiencies within 3 months
//                                             </option>
//                                             <option value={`Affiliation but under Zero Admissions Category for AY ${acYear} due to the serious deficiencies and violation of norms as identified by the Committees`}>
//                                                 Affiliation but under Zero Admissions Category for AY {acYear} due to the serious deficiencies and violation of norms as identified by the Committees
//                                             </option>
//                                         </Field>
//                                         {/* <ErrorMessage name="ecDecision" component="div" className="text-error" /> */}
//                                     </bie.Col>
//                                 )}



//                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                     <label className=''>Proceedings of CHE, according to provisional approval to the Society / College to offer programs for the academic year 2026-27</label>
//                                     <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
//                                     <ErrorMessage name="gortNo3" component="div" className="text-error" />

//                                 </bie.Col>


//                                 {/* {clgCategory > 0 || pageName === "OAMDC" && (<> */}
//                                 {/* <bie.Row> */}
//                                 {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory'>Proceedings of CHE, according to provisional approval to the Society / College to offer programs for the academic year 2026-27</label>
//                                         <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
//                                         <ErrorMessage name="gortNo3" component="div" className="text-error" />

//                                     </bie.Col> */}
//                                 {clgCategory > 0 || pageName === "OAMDC" && (<>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory'>Dated</label>
//                                         <Field type='date' name="gortDate3" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                         <ErrorMessage name="gortDate3" component="div" className="text-error" />

//                                     </bie.Col>
//                                 </>)}
//                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                     <label className='field-mandatory mb-1'> Registrar Remarks: </label>
//                                     <Field as='select' name="registrarRemarks" className='form-control mb-2'>
//                                         <option value="">--Select--</option>
//                                         <option value="Temporary Affiliation">Temporary Affiliation</option>
//                                         <option value="Permanent Affiliation">Permanent Affiliation</option>
//                                         <option value="Conditional Affiliation">Conditional Affiliation</option>
//                                         {pageName === "NONOAMDC" && (
//                                             <option value="Affiliation but under Zero Admissions Category">Affiliation but under Zero Admissions Category</option>
//                                         )}
//                                     </Field>
//                                     <ErrorMessage name="registrarRemarks" component="div" className="text-error" />

//                                 </bie.Col>
//                                 <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
//                                     <label className='mb-1' >Remarks: </label>
//                                     <Field as='textarea' name="remarks" className='form-control mb-2' />
//                                 </bie.Col>
//                                 {/* </bie.Row>
//                                     </>)}

//                                     <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
//                                         <label className='mb-1' >Remarks: </label>
//                                         <Field as='textarea' name="remarks" className='form-control mb-2' />
//                                     </bie.Col>

//                                     {/* </bie.Row> */}
//                                 {/* <bie.Row> */}

//                             </bie.Row>

//                             {/* law code  */}
//                             {clgCategory > 0 || pageName === "OAMDC" && (<>
//                                 {/* <bie.Row> */}
//                                 {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory'>Proceedings of CHE, according to provisional approval to the Society / College to offer programs for the academic year 2026-27</label>
//                                         <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
//                                         <ErrorMessage name="gortNo3" component="div" className="text-error" />

//                                     </bie.Col> */}
//                                 {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='field-mandatory'>Dated</label>
//                                         <Field type='date' name="gortDate3" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                         <ErrorMessage name="gortDate3" component="div" className="text-error" />

//                                     </bie.Col> */}
//                                 {/* </bie.Row> */}
//                                 {pageName === "OAMDC" && (<>

//                                     <b style={{ fontSize: "19px", color: "brown" }}> Optional:</b>


//                                 </>)}
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Reference Number of the Proceedings/Order/Letter/Report:2.</label>
//                                         <Field type='text' name="gortNo4" className='form-control mb-2' maxLength={60} />
//                                     </bie.Col>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Date of Reference Number of the Proceedings/Order/Letter/Report:2.</label>
//                                         <Field type='date' name="gortDate4" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                     </bie.Col>
//                                 </bie.Row>
//                             </>)}
//                             {pageName === "OAMDC" && (
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Reference Number of the Proceedings of Latest EC Meeting</label>
//                                         <Field type='text' name="gortNo2" className='form-control mb-2' maxLength={60} />
//                                         <ErrorMessage name="gortNo2" component="div" className="text-error" />
//                                     </bie.Col>
//                                 </bie.Row>
//                             )}

//                             {/* except law nonoamdc and oamdc code  */}
//                             {clgCategory === 0 && (
//                                 <bie.Row>
//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1'>Upload University EC Resolution Document:</label>
//                                         <input type="file" name="universityEcDoc" className="form-control mb-2" accept='application/pdf'
//                                             onChange={(e) => {
//                                                 let filename = 'universityEcDoc';
//                                                 let path = "/Uploads/AffiliationOrder_2023/";
//                                                 ImagePdfBucket(e, afflOrderGenFormik, path, `universityEcDoc`, filename, "pdf");
//                                             }}
//                                         />
//                                     </bie.Col>

//                                     <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
//                                         <label className='mb-1' >Date of Latest EC Meeting :</label>
//                                         <Field type='date' name="universityEcDate" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
//                                         {/* <ErrorMessage name="universityEcDate" component="div" className="text-error" /> */}
//                                     </bie.Col>
//                                 </bie.Row>
//                             )}


//                             <br />

//                             <div className="text-end">
//                                 {hidepdf === false ? (<>
//                                     <br />
//                                     <br />

//                                     {pageName === "OAMDC" && (
//                                         <button type="submit" className="btn btn-success btn-sm rounded">
//                                             Submit
//                                         </button>
//                                     )}
//                                     {pageName === "NONOAMDC" && afflOrderGenFormik?.values?.registrarRemarks !== "Affiliation but under Zero Admissions Category" && (<>
//                                         <button type="submit" className="btn btn-success btn-sm rounded" >

//                                             Submit
//                                         </button> &emsp;
//                                     </>)}

//                                 </>) : (<>
//                                     <button type="button" className="btn btn-primary btn-sm rounded" onClick={() => { showViewPDF(config.url.FILE_DOWNLOAD_URL + viewpdf); }}

//                                     >View Pdf</button> &emsp;
//                                 </>)}


//                             </div>
//                         </bie.Row>


//                         <bie.Modal show={modal} onHide={handleClose} size="xl" backdrop="static">
//                             <bie.Modal.Header style={{ backgroundColor: '#6f7cc3' }} className="text-white">
//                                 <bie.Modal.Title style={{ textAlign: "center", width: "100%" }}> PDF View</bie.Modal.Title>
//                             </bie.Modal.Header>
//                             <bie.Modal.Body style={{ width: '100%', padding: 0 }}>
//                                 {pdfUrl && (
//                                     <embed
//                                         src={pdfUrl}
//                                         type="application/pdf"
//                                         width="100%"
//                                         height="800px"
//                                     />
//                                 )}
//                             </bie.Modal.Body>
//                             <bie.Modal.Footer>
//                                 <bie.Button variant="secondary" onClick={handleClose}>Close</bie.Button>
//                                 <bie.Button variant="primary" onClick={dskConfirmationFunc}>DigiSign</bie.Button>
//                             </bie.Modal.Footer>
//                         </bie.Modal>
//                     </Form>
//                 </FormikProvider>
//             </bie.Container >
//         </>
//     )
// }
















import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import * as Yup from 'yup';
import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { digisignFunction } from '../../CommonUtils/DIGISIGN/digisignFunction';
import { showPDF } from '../../CommonUtils/DIGISIGN/convertFileToBase64';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { BackButton } from '../../CommonUtils/CommonServices';
export default function AfflOrderGenDetails() {
    const location = useLocation()
    const acYear = sessionStorage.getItem('ac_year');
    const collegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const [viewpdf, setViewpdf] = useState('');
    const [hidepdf, setHidepdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    let pageName = location?.state?.type;

    const [collegeRecommendation, setCollegeRecommendation] = useState('');
    function getRecommendation() {
        const url = `${config.url.API_URL}recomdation/${collegeCode}/${acYear}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.scode === "01") {
                    setCollegeRecommendation(res?.data?.recomdation[0]);
                } else {
                    setCollegeRecommendation('');
                }
            })

    }
    const [clgCategory, setClgCategory] = useState('');
    function GetCollegeCategory() {
        let url = config.url.API_URL + "clgCategory/" + collegeCode + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res) {
                setClgCategory(res?.data)
                afflOrderGenFormik.setFieldValue("clgcatflag", res?.data)

            } else {
                setClgCategory([])
            }
        })
    }
    useEffect(() => {
        GetCollegeCategory();
        getRecommendation();
    }, [])


    const AfflOrderDetailsValidation = Yup.object().shape({
        accordedBy: Yup.string().required(ERROR_MSG).nullable(),
        authorityBy: Yup.string().required(ERROR_MSG).nullable(),
        afflOrderProcNo202223: Yup.string().required(ERROR_MSG).nullable(),

        afflOrder202021Date: Yup.string().when(['clgcatflag', "clgtype"], {
            is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        afflOrderProcNo202021: Yup.string().when(['clgcatflag', "clgtype"], {
            is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        universityEcDate: Yup.string().nullable().when("clgcatflag", {
            is: (value) => value === 0,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        ecDecision: Yup.string().when(['clgcatflag', "clgtype"], {
            is: (clgcatflag, clgtype) => clgcatflag === 0 && clgtype === "NONOAMDC",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),

        registrarRemarks: Yup.string().required(ERROR_MSG).nullable(),
    });

    const [modal, setModal] = useState(false);
    const handleClose = () => {
        setModal(false);
        setPdfUrl('');
    };

    const afflOrderGenFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            collCode: collegeCode,
            acYear: acYear,
            clgcatflag: "",
            clgtype: pageName,
            finalPdfPath: "",
            universityEcDoc: "",
            gortNo: "",
            gortDate: "",
            gortNo2: "",
            gortDate2: '',
            gortNo3: "",
            gortNo4: "",
            gortDate3: "",
            gortDate4: "",
            accordedBy: "",
            authorityBy: "",
            afflOrder202021Date: "",
            afflOrderProcNo202021: "",
            afflOrder202223Date: "",
            afflOrderProcNo202223: "",
            universityEcDate: "",
            ecDecision: "",
            registrarRemarks: "",
            afflType: "",
            remarks: "",

        },
        validationSchema: AfflOrderDetailsValidation,
        validateOnBlur: true,
        validateOnChange: true,
        context: {
            clgCategory,
        },
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,


            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAfflOrderGeneration`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.Status === true) {
                            setHidepdf(true)
                            successAlert2(res?.data?.sdesc);
                            setViewpdf(res?.data?.path)
                        } else {
                            failureAlert("Failed to submit");
                        }
                    });
                }
            });
        }
    })


    async function dskConfirmationFunc() {
        if (viewpdf !== null && viewpdf !== undefined && viewpdf !== "") {
            try {
                let img = config.url.FILE_DOWNLOAD_URL + viewpdf
                const base64Data = await showPDF(img);
                const extractedData = base64Data;
                let postData = {
                    path: config.url.API_URL + "saveAfflOrder",
                    params: {
                        collCode: collegeCode,
                        acYear: acYear,
                        // finalPdfPath: viewpdf,
                    }
                }
                digisignFunction(extractedData, "-1", postData, "", pageName);
            } catch (error) {
                console.error("Error:", error);
            }
        }
    }
    const showViewPDF = (imgg) => {
        ConvertFileToBase64(imgg).then(base64Data => {
            const extractedData = base64Data.split(',')[1];
            const binaryData = atob(extractedData);
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData?.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
            setModal(true);
        })
    };

    async function ConvertFileToBase64(fileUrl) {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader?.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        })
    }

    return (
        <>
            <CommonFormHeading heading={`Affiliation Order Details ${acYear}`} />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <BackButton />
                <FormikProvider value={afflOrderGenFormik}>
                    <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="form_adjust" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            {pageName === "OAMDC" && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Final Recommendations of CDC Dean:</label>
                                        <b>  {collegeRecommendation?.final_recomondation_cdc_dean}</b>
                                    </bie.Col>
                                </bie.Row>
                            )}
                            {/* except law nonoamdc and oamdc code  */}
                            {clgCategory === 0 && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Upload University EC Resolution Document:</label>
                                        <input type="file" name="universityEcDoc" className="form-control mb-2" accept='application/pdf'
                                            onChange={(e) => {
                                                let filename = 'universityEcDoc';
                                                let path = "/Uploads/AffiliationOrder_2023/";
                                                ImagePdfBucket(e, afflOrderGenFormik, path, `universityEcDoc`, filename, "pdf");
                                            }}
                                        />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Date of Latest EC Meeting :</label>
                                        <Field type='date' name="universityEcDate" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                        <ErrorMessage name="universityEcDate" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                            )}
                            {/* except law college nonoamdc */}
                            {clgCategory === 0 && pageName === "NONOAMDC" && (<>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Reference Number of the Proceedings of AICTE/CHE/PCI/BCI/NCTE that stands as reference in the Affiliation Order {acYear}: 1.</label>
                                        <Field type='text' name="gortNo" className='form-control' maxLength={60} />
                                        <ErrorMessage name="gortNo" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Date of Proceedings of AICTE/CHE/PCI/BCI/NCTE that stands as reference in the  Affiliation Order {acYear}:1</label>
                                        <Field type='date' name="gortDate" className='form-control mb-2' />
                                        <ErrorMessage name="gortDate" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Reference Number of the Proceedings of Latest EC Meeting:2</label>
                                        <Field type='text' name="gortNo2" className='form-control mb-2' maxLength={60} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Date of Reference Number of the Proceedings of Latest EC Meeting:2</label>

                                        <Field type='date' name="gortDate2" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    </bie.Col>
                                </bie.Row>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Reference Number of the Proceedings/Order/Letter/Report:3</label>

                                        <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Date of Reference Number of the Proceedings/Order/Letter/Report:3</label>

                                        <Field type='date' name="gortDate3" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    </bie.Col>
                                </bie.Row>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Reference Number of the Proceedings/Order/Letter/Report:4</label>

                                        <Field type='text' name="gortNo4" className='form-control mb-2' maxLength={60} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label >Date of Reference Number of the Proceedings/Order/Letter/Report:4</label>

                                        <Field type='date' name="gortDate4" className='form-control mb-2' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    </bie.Col>
                                </bie.Row>
                            </>)}
                            {pageName === "OAMDC" && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1'>Reference Number of the Proceedings of Latest EC Meeting</label>
                                        <Field type='text' name="gortNo2" className='form-control mb-2' maxLength={60} />
                                        <ErrorMessage name="gortNo2" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                            )}
                            {/* law code  */}
                            {clgCategory > 0 || pageName === "OAMDC" && (<>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Reference Number of the Proceedings/Order/Letter/Report  : 1</label>
                                        <Field type='text' name="gortNo3" className='form-control mb-2' maxLength={60} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label >Date of Reference Number of the Proceedings/Order/Letter/Report : 1</label>
                                        <Field type='date' name="gortDate3" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    </bie.Col>
                                </bie.Row>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Reference Number of the Proceedings/Order/Letter/Report:2.</label>
                                        <Field type='text' name="gortNo4" className='form-control mb-2' maxLength={60} />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1' >Date of Reference Number of the Proceedings/Order/Letter/Report:2.</label>
                                        <Field type='date' name="gortDate4" className='form-control' max={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
                                    </bie.Col>
                                </bie.Row>
                            </>)}
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                    <label className='field-mandatory'>Competent Authority that has given Permission (EOA/EOP/Any Other Permission Proceedings that is pre-requisite for Granting Affiliation):</label>
                                    <Field type='text' name="accordedBy" className='form-control' maxLength={60} />
                                    <ErrorMessage name="accordedBy" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                    <label className='field-mandatory mb-1'>Affiliation Order {acYear} being approved by: </label>
                                    <Field as="select" name="authorityBy" className="form-control mb-2 mt-3">
                                        <option value="">--Select--</option>
                                        <option value="REGISTRAR">REGISTRAR</option>
                                        <option value="VICE-CHANCELLOR">VICE-CHANCELLOR</option>
                                    </Field>
                                    <ErrorMessage name="authorityBy" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>
                            {/* nonoamdc except law */}
                            {clgCategory === 0 && pageName === "NONOAMDC" && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='field-mandatory'>Date of Affiliation Order {AC_YEAR_OLD}:</label>
                                        <Field type='date' name="afflOrder202021Date" className='form-control mb-2 mt-3'
                                            onKeyDown={(e) => { e.preventDefault() }} />
                                        <ErrorMessage name="afflOrder202021Date" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Proceedings Number of Affiliation Order {AC_YEAR_OLD}: </label>
                                        <Field type='text' name="afflOrderProcNo202021" className='form-control mb-2 mt-3' maxLength={100} />
                                        <ErrorMessage name="afflOrderProcNo202021" component="div" className="text-error" />
                                    </bie.Col>

                                </bie.Row>
                            )}
                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={6} xxl={6} className='mb-2'>
                                <label className='field-mandatory mb-1'>Date of Affiliation Order {acYear}:</label>
                                <Field type='date' name="afflOrder202223Date" className='form-control mb-2 mt-3'
                                    value={new Date().toISOString().split('T')[0]}
                                    readOnly />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                <label className='field-mandatory mb-1'>University Proceedings Number of Affiliation Order {acYear}: </label>
                                <Field type='text' name="afflOrderProcNo202223" className='form-control mb-2 mt-3' maxLength={60} />
                                <ErrorMessage name="afflOrderProcNo202223" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Row>
                                {clgCategory === 0 && pageName === "NONOAMDC" && (
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                        <label className='field-mandatory mb-1'>EC Decision : </label>
                                        <Field as='select' name="ecDecision" className='form-control mb-2'>
                                            <option value="">--Select--</option>
                                            <option value="Permanent Affiliation">Permanent Affiliation</option>
                                            <option value={`Temporary Affiliation for AY ${acYear}`}>
                                                Temporary Affiliation for AY {acYear}
                                            </option>
                                            <option value={`Conditional Affiliation for AY ${acYear} subject to rectifying the deficiencies within 3 months`}>
                                                Conditional Affiliation for AY {acYear} subject to rectifying the deficiencies within 3 months
                                            </option>
                                            <option value={`Affiliation but under Zero Admissions Category for AY ${acYear} due to the serious deficiencies and violation of norms as identified by the Committees`}>
                                                Affiliation but under Zero Admissions Category for AY {acYear} due to the serious deficiencies and violation of norms as identified by the Committees
                                            </option>
                                        </Field>
                                        <ErrorMessage name="ecDecision" component="div" className="text-error" />
                                    </bie.Col>
                                )}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                    <label className='field-mandatory mb-1'> Registrar Remarks: </label>
                                    <Field as='select' name="registrarRemarks" className='form-control mb-2'>
                                        <option value="">--Select--</option>
                                        <option value="Temporary Affiliation">Temporary Affiliation</option>
                                        <option value="Permanent Affiliation">Permanent Affiliation</option>
                                        <option value="Conditional Affiliation">Conditional Affiliation</option>
                                        {pageName === "NONOAMDC" && (
                                            <option value="Affiliation but under Zero Admissions Category">Affiliation but under Zero Admissions Category</option>
                                        )}
                                    </Field>
                                    <ErrorMessage name="registrarRemarks" component="div" className="text-error" />

                                </bie.Col>

                                {/* <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                    <label className='mb-1' >Remarks: </label>
                                    <Field as='textarea' name="remarks" className='form-control mb-2' />
                                </bie.Col> */}

                            </bie.Row>
                            <div className="text-end">
                                {hidepdf === false ? (<>
                                    {pageName === "OAMDC" && (
                                        <button type="submit" className="btn btn-success btn-sm rounded">
                                            Submit
                                        </button>
                                    )}
                                    {pageName === "NONOAMDC" && afflOrderGenFormik?.values?.registrarRemarks !== "Affiliation but under Zero Admissions Category" && (<>
                                        <button type="submit" className="btn btn-success btn-sm rounded" >

                                            Submit
                                        </button> &emsp;
                                    </>)}

                                </>) : (<>
                                    <button type="button" className="btn btn-primary btn-sm rounded" onClick={() => { showViewPDF(config.url.FILE_DOWNLOAD_URL + viewpdf); }}

                                    >View Pdf</button> &emsp;
                                </>)}


                            </div>
                        </bie.Row>

                        <bie.Modal show={modal} onHide={handleClose} size="xl" backdrop="static">
                            <bie.Modal.Header style={{ backgroundColor: '#6f7cc3' }} className="text-white">
                                <bie.Modal.Title style={{ textAlign: "center", width: "100%" }}> PDF View</bie.Modal.Title>
                            </bie.Modal.Header>
                            <bie.Modal.Body style={{ width: '100%', padding: 0 }}>
                                {pdfUrl && (
                                    <embed
                                        src={pdfUrl}
                                        type="application/pdf"
                                        width="100%"
                                        height="800px"
                                    />
                                )}
                            </bie.Modal.Body>
                            <bie.Modal.Footer>
                                <bie.Button variant="secondary" onClick={handleClose}>Close</bie.Button>
                                <bie.Button variant="primary" onClick={dskConfirmationFunc}>DigiSign</bie.Button>
                            </bie.Modal.Footer>
                        </bie.Modal>
                    </Form>
                </FormikProvider>
            </bie.Container >
        </>
    )
}